import { Component, HostListener,OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Header } from '@elan/modules/user/components/header/header';
import { Footer } from '@elan/modules/user/components/footer/footer';
import { Sidebar } from '@elan/modules/user/components/sidebar/sidebar';
@Component({
  selector: 'app-user-layout',
  standalone: true,
  imports: [CommonModule,RouterOutlet,Header,Footer,Sidebar],
  templateUrl: './user-layout.html',
  styleUrl: './user-layout.scss',
})
export class UserLayout implements OnInit {
 isCollapsed = false;// expanded
  
 ngOnInit(): void {
    this.updateSidebarForScreen(true);
  }

  @HostListener('window:resize')
  onResize() {
    this.updateSidebarForScreen(false);
  }
  private updateSidebarForScreen(isInit: boolean) {
    const isMobile = window.innerWidth <= 767;
    const next = isMobile ? true : false; // mobile: collapsed, desktop: expanded

    if (this.isCollapsed !== next) {
      this.isCollapsed = next;
    }
  }

  onHeaderToggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  onSidebarCollapsedChange(val: boolean) {
    this.isCollapsed = val;
  }

  // toggleSidebar() {
  //   alert('Sidebar toggled');
  //   this.isCollapsed = !this.isCollapsed;
  // }
}
